<template>
    <div>
        <el-upload
                action=""
                accept="image/*"
                list-type="picture-card"
                :file-list="ImageList"
                :on-success="onSuccess"
                :on-error="uploadOnError"
                :disabled="getLoadState"
                :http-request="httpRequest"
                :limit="9"
        >
            <i slot="default" class="el-icon-plus"></i>
            <div slot="file" slot-scope="{file}">
                <img
                        class="el-upload-list__item-thumbnail"
                        :src="file.url" alt=""
                >
                <span class="el-upload-list__item-actions">
        <span
                class="el-upload-list__item-preview"
                @click="handlePictureCardPreview(file)"
        >
          <i class="el-icon-zoom-in"></i>
        </span>
        <span
                v-if="!disabled && from !== 'init'"
                class="el-upload-list__item-delete"
                @click="handleDownload(file)"
        >
          <i class="el-icon-download"></i>
        </span>
        <span
                v-if="!disabled && from == 'init'"
                class="el-upload-list__item-delete"
                @click="handleRemove(file)"
                v-show="!file.noremove"
        >
          <i class="el-icon-delete"></i>
        </span>
      </span>
            </div>
            <div slot="tip" class="el-upload__tip" v-if="state != '已取消' && state != '已拒绝' && state != '已完成' && from == 'init'">最多可上传9张图片，支持jpg、png、gif、bmp格式。</div>
        </el-upload>
        <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
        <!-- 利用A标签进行下载 -->
        <a id="downLoad" :href="downFile.attaFileUrl" :download="downFile.attaFileName" target="_blank"/>
        <!--   上面上传图片 下面上传文件     -->
        <el-upload
                :action="API_URL"
                :file-list="fileList"
                :data="upload_file"
                :on-success="successChangeFile"
                :on-error="uploadOnError"
                :on-remove="uploadRemoveFile"
                :before-remove="beforeremove"
                :before-upload="beforeUpload"
                :headers="UPLOAD_HEADERS"
                :disabled="getLoadState"
                :on-preview="handleDownload"
                class="fileLoad"
                v-if="onlyImg"
        >
            <el-button size="medium">添加附件</el-button>
            <div slot="tip" class="el-upload__tip" v-if="state != '已取消' && state != '已拒绝' && state != '已完成' && from == 'init'">仅支持pdf、xls、xlsx、doc、docx、txt、rar、zip格式，文件小于30M。</div>
        </el-upload>
    </div>
</template>

<script>
    import {HosUploadMixin} from "../../lib/mixins/hosUpLoad"
    import {fileToNase64} from "../../lib/hos/until"
    import {hosService} from "../../lib/service/hos"
    export default {
        name: "concul-file-load",
        props:{
            from:{
                type:String,
                default:'init'
            },
            // atta:{
            //     type:Array,
            //     default:() => {
            //         return []
            //     }
            // },
            picList:{
                type:Array,
                default:() => {
                    return []
                }
            },
            filelist:{
                type:Array,
                default:() => {
                    return []
                }
            },
            state:{
                type:String,
                default: 'apply'
            },
            onlyImg:{
                type:Boolean,
                default: true
            }
        },
        mixins:[HosUploadMixin],
        data() {
            return {
                dialogImageUrl: '',
                dialogVisible: false,
                disabled: false,
                ImageList: [],//图片列表
                fileList:[],//文件列表
                attaIdList:[],
                //下载文件对象
                downFile:{
                    attaFileUrl:"",
                    attaFileName:""
                }
            };
        },
        methods: {
            getAttaList(){
                let attaList = {};
                attaList.picList =this.ImageList.map(r => r.id);
                attaList.fileList = this.fileList.map(r => r.id);
                return attaList
            },
            handleRemove(file) {
                let arr = this.ImageList.filter(function(item){
                    return item.id != file.id;
                })
                this.ImageList = arr;
            },
            handlePictureCardPreview(file) {
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },
            successChangeFile(response,file,fileList){
                if (response && response.code !== '0'){
                    this.$message.error(response.msg);
                    return
                }
                this.fileList = fileList.map(r => {
                    if (r.response && r.response.code === '0') {
                        r.url = r.response.obj.attaFileUrl;
                        r.id = r.response.obj.id;
                    }
                    return r;
                });
            },
            beforeremove(file){
                if(file.noremove){
                    return false
                }
            },
            uploadRemoveFile(file){
                let arr = this.fileList.filter(function(item){
                    return item.response.obj.id != file.response.obj.id;
                })
                this.fileList = arr;
            },
            handleDownload(file){
                const down = document.getElementById('downLoad');
                if(file.attaFileUrl){
                    this.downFile.attaFileUrl = file.attaFileUrl;
                    this.downFile.attaFileName = file.attaFileName;
                    this.$nextTick(function(){
                        down.click();
                    })
                }
            },
            async httpRequest(option){
                let file = option.file;
                let type = file.type.split('/')[0] || '';
                if(type !== 'image' && type !== 'Image'){
                    option.onError();
                }
                const fileBase = await fileToNase64(file);//文件转base64
                const data = await hosService.loadBase({
                    module:"BASE",
                    fileType:"IMAGE",
                    fileName:file.name,
                    base64:fileBase
                });
                if(data.code == 0){
                    return data
                }else{
                    option.onError();
                }
            },
            hideImgRadio(){
                // this.ImageList = this.picList;
                // this.fileList = this.filelist;
                let image = [];
                let file = [];
                for(let i in this.picList){
                    let obj ={
                        name:this.picList[i].attaFileName,
                        url:this.picList[i].attaFileUrl,
                        noremove:true,
                        id:this.picList[i].id,
                        response:{
                            code:0,
                            obj:this.picList[i]
                        }
                    };
                    image.push(obj);
                }

                for(let i in this.filelist){
                    let obj ={
                        name:this.filelist[i].attaFileName,
                        url:this.filelist[i].attaFileUrl,
                        noremove:true,
                        id:this.filelist[i].id,
                        response:{
                            code:0,
                            obj:this.filelist[i]
                        }
                    };
                    file.push(obj);
                }
                this.ImageList = image;
                this.fileList = file;
            }
        },
        computed:{
            upload_data(){
                return {...this.UPLOAD_PARAMS, fileType: 'IMAGE', module: 'BASE'};
            },
            // upload_file(){
            //     return {...this.UPLOAD_PARAMS, fileType: 'OTHER', module: 'BASE'};
            // },
            //判断是否能上传的状态
            getLoadState(){
                if(this.from == 'init'){
                    if(this.state == 'apply' || this.state == 'WAIT_EXAMINE' || this.state == 'FINSH'|| this.state == '待审核'|| this.state == '待处理'){
                        return false
                    }
                    return true
                }else{
                    return true
                }
            }
        },
        watch:{
            picList(){
                this.ImageList = this.picList;
            },
            filelist(){
                this.fileList = this.filelist;
            },
            atta(){
                //this.hideImgRadio();
            },
            ImageList(){
                if(this.ImageList.length >= 9 || this.state == '已取消' || this.state == '已拒绝' || this.from != 'init' || this.state == '已完成'){
                    document.getElementsByClassName("el-upload--picture-card")[0].classList.add("hiddenLoad");
                   // document.getElementsByClassName("el-upload--text")[0].classList.add("hiddenLoad");
                }else{
                    document.getElementsByClassName("el-upload--picture-card")[0].classList.remove("hiddenLoad");
                   // document.getElementsByClassName("el-upload--text")[0].classList.remove("hiddenLoad");
                }
            },
            fileList(){
                if(this.state == '已取消' || this.state == '已拒绝' || this.from != 'init' || this.state == '已完成'){
                     document.getElementsByClassName("el-upload--text")[0].classList.add("hiddenLoad");
                }else{
                     document.getElementsByClassName("el-upload--text")[0].classList.remove("hiddenLoad");
                }
            }
        },
        created() {
            if(this.picList.length > 0 || this.filelist.length > 0 ){
                this.hideImgRadio();
            }
        }
    }
</script>

<style>
    .hiddenLoad{
        display: none;
    }

</style>
